import { uuid } from "@/interfaces";
import { VendorsRepository } from "@/repositories/vendors.repository";

export async function getVendorDetail(vendorId: uuid) {
  return VendorsRepository.getDetail(vendorId);
}

export async function uploadVendorDocument(vendorId: uuid, file: File, expiresAt?: string | Date) {
  return VendorsRepository.uploadDocument(vendorId, file, expiresAt);
}

export async function deleteVendorDocument(docId: uuid) {
  return VendorsRepository.deleteDocument(docId);
}

export async function listVendorDocuments(vendorId: uuid, page: number, pageSize: number) {
  return VendorsRepository.listDocuments(vendorId, page, pageSize);
}

export async function listVendorProperties(vendorId: uuid, page: number, pageSize: number) {
  return VendorsRepository.listVendorProperties(vendorId, page, pageSize);
}

export async function addVendorProperty(vendorId: uuid, propertyId: uuid) {
  return VendorsRepository.addVendorProperty(vendorId, propertyId);
}

export async function removeVendorProperty(vendorId: uuid, propertyId: uuid) {
  return VendorsRepository.removeVendorProperty(vendorId, propertyId);
}

export async function getAvailableProperties(vendorId: uuid, search?: string) {
  return VendorsRepository.getAvailableProperties(vendorId, search);
}
